import Vue from 'vue';
export default Vue.extend({
    name: 'bonusConvertWidget',
    props: {
        loadError: {
            type: Boolean,
            required: true
        },
        isRetry: {
            type: Boolean,
            required: true
        },
        balance: {
            type: Object,
            required: true
        },
        prices: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        assetsList: ['USDT', 'BNB', 'FDUSD', 'USDC', 'BTC'],
        selectedAssetIndex: 0,
        form: {
            valid: false,
            input: {
                value: '',
                touched: false,
                maskConfig: {
                    alias: 'numeric',
                    placeholder: '',
                    allowMinus: false,
                    digits: 4,
                    min: 0,
                    max: Infinity
                },
                rules: []
            }
        }
    }),
    computed: {
        assetsSelectList() {
            return this.assetsList.map((asset, index) => ({
                key: index,
                value: asset,
                mark: asset
            }));
        },
        canConvert() {
            const canConvert = this.form.valid && this.form.input.value.length > 0;
            return canConvert;
        },
        availableCurrentAsset() {
            const asset = this.assetsList[this.selectedAssetIndex];
            const balance = this.balance[asset];
            return balance;
        },
        bonusAmount() {
            var _a;
            const asset = this.assetsList[this.selectedAssetIndex];
            const assetAmount = this.NS(this.form.input.value.length ? this.form.input.value : '0');
            if (asset === 'USDT')
                return assetAmount;
            const bonusAmount = assetAmount.multipliedBy((_a = this.prices[asset]) !== null && _a !== void 0 ? _a : 0);
            return bonusAmount;
        }
    },
    methods: {
        doConvert() {
            if (!this.canConvert)
                return;
            const asset = this.assetsList[this.selectedAssetIndex];
            this.$emit('onConvert', { amount: this.NS(this.form.input.value), asset });
        },
        handleClickSetAll() {
            this.form.input.touched = true;
            this.form.input.value = this.availableCurrentAsset.toFixed(this.form.input.maskConfig.digits, 1);
        },
        handleAssetChange(asset) {
            this.selectedAssetIndex = asset.key;
            this.form.input.maskConfig.digits = this.assetsList[this.selectedAssetIndex] === 'BTC' ? 8 : 4;
            this.form.input.touched = false;
            this.form.input.value = '';
            this.form.input.rules = [];
        }
    },
    watch: {
        'form.input.touched'(v) {
            if (!v)
                return;
            this.form.input.rules = [
                (v) => {
                    if (v.length === 0)
                        return true;
                    return this.NS(v).isGreaterThan(0) || this.$t('bonusesPage.widgets.numberMoreThanZero');
                },
                (v) => {
                    if (v.length === 0)
                        return true;
                    const asset = this.assetsList[this.selectedAssetIndex];
                    const balance = this.balance[asset];
                    if (balance.isGreaterThanOrEqualTo(this.NS(v)))
                        return true;
                    const fixedLengthBalance = balance.toFixed(this.form.input.maskConfig.digits, 1);
                    const moneyFormatBalance = this.$options.filters.formatMoney(fixedLengthBalance);
                    const formattedBalance = this.$options.filters.removeTrailingZeros(moneyFormatBalance, ',');
                    return this.$t('bonusesPage.widgets.amountContBeMoreThanBalance', { balance: formattedBalance, asset: asset });
                }
            ];
        }
    }
});
